import React from "react";
import { ArrowLeftIcon } from "lucide-react";
import { CutPlan } from "./CutPlan";
type PageHeroProps = {
  eyebrow: string;
  title: string;
  copy: string;
  children?: React.ReactNode;
};
function PageHero({
  eyebrow,
  title,
  copy,
  children
}: PageHeroProps) {
  return <section className="relative overflow-hidden bg-pfpc-navy text-pfpc-offwhite" data-id="element-191" data-mp="2xzs3vo9f57sw">
      <div className="absolute inset-y-0 right-0 hidden w-[46%] overflow-hidden border-l border-pfpc-offwhite/[.06] lg:block" aria-hidden="true" data-id="element-192" data-mp="2xxfs5su97toa">
        <CutPlan dark className="h-full w-full opacity-25" data-id="element-193" data-mp="25c646r3banbb" />
      </div>
      <div className="container-shell relative py-11 md:py-14 lg:py-16" data-id="element-194" data-mp="2aahef2xiqzu2">
        <a href="/" className="mb-6 inline-flex min-h-11 items-center gap-2 text-sm font-bold text-pfpc-offwhite/70 underline decoration-pfpc-orange underline-offset-4 hover:text-pfpc-offwhite focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pfpc-orange md:mb-7" data-id="element-195" data-mp="2a84pg5tcfp7i">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-196" data-mp="1misgn71xhj5q" /> Back to home
        </a>
        <div className="max-w-[700px]" data-id="element-197" data-mp="1wc0nqf8qrwk5">
          <p className="section-label mb-3 text-pfpc-orange" data-id="element-198" data-mp="1wf69plm2qibn">{eyebrow}</p>
          <h1 className="max-w-[20ch] font-heading text-[36px] font-extrabold leading-[1.08] tracking-[-.025em] text-pfpc-offwhite md:text-[48px] md:leading-[1.05] lg:text-[52px]" data-id="element-199" data-mp="1reindd8sipnr">
            {title}
          </h1>
          <p className="mt-4 max-w-[58ch] text-[16px] leading-7 text-pfpc-offwhite/76 md:text-[18px]" data-id="element-200" data-mp="1ilf42obgril7">
            {copy}
          </p>
          {children ? <div className="mt-6 grid gap-3 sm:flex sm:flex-wrap" data-id="element-201" data-mp="18my6v9lxm7qp">{children}</div> : null}
        </div>
      </div>
    </section>;
}
export { PageHero };